import { jsx as _jsx } from "react/jsx-runtime";
import App from './App';
import Layout from './components/Layout';
import NotFound from './components/NotFound';
import Privacy from './components/Privacy';
import ReleaseDetail from './components/ReleaseDetail';
import Releases from './components/Releases';
import Terms from './components/Terms';
import { releases } from './data/releases';
// サーバー用のルーティング設定
export const routes = [
    {
        element: /*#__PURE__*/ _jsx(Layout, {}),
        children: [
            {
                path: '/',
                element: /*#__PURE__*/ _jsx(App, {})
            },
            {
                path: '/terms',
                element: /*#__PURE__*/ _jsx(Terms, {})
            },
            {
                path: '/privacy',
                element: /*#__PURE__*/ _jsx(Privacy, {})
            },
            {
                path: '/releases',
                element: /*#__PURE__*/ _jsx(Releases, {}),
                loader: async ()=>{
                    // サーバーサイドでデータを取得して返す
                    return releases;
                }
            },
            {
                path: '/releases/:id',
                element: /*#__PURE__*/ _jsx(ReleaseDetail, {}),
                loader: async ({ params })=>{
                    // サーバーサイドでIDに対応するデータを取得して返す
                    const release = releases.find((r)=>r.id === params.id);
                    if (!release) {
                        throw new Response('Not Found', {
                            status: 404
                        });
                    }
                    return release;
                }
            },
            {
                path: '*',
                element: /*#__PURE__*/ _jsx(NotFound, {})
            }
        ]
    }
]; // サーバー用のルーティング設定を作成
 // 各パスに対応するコンポーネントを指定
 // これにより、サーバーサイドレンダリング時に適切なコンポーネントが表示される
